export default __webpack_public_path__ + "/static/img/confirmation-checkmark-circled.svg";